import { DistributorObject, RxShoppingCartObject } from "../sale/SalePage";

export interface RxPaymentObject {
	invoiceInfo: {
		isCompany: boolean;
		nameSurname: string;
		company: string;
		identityId: string;
		taxAdmin: string;
		taxNo: string;
		address: string;
		district: string;
		province: string;
		country: string;
	};
	deliveryInfo: {
		nameSurname: string;
		company: string;
		address: string;
		district: string;
		province: string;
		country: string;
		phone: string;
		note: string;
	};
	saleDetail: RxShoppingCartObject;
	maxInstallment: number;
	isAgreementApprove: boolean;
	pan: string;
	cv2: string;
	Ecom_Payment_Card_ExpDate_Year: string;
	Ecom_Payment_Card_ExpDate_Month: string;
	cardType: string;
	instalment: string;
	clientid: string;
	oid: string;
	amount: string;
	okUrl: string;
	failUrl: string;
	storetype: string;
	rnd: string;
	hash: string;
	firmaadi: string;
	islemtipi: string;
	currency: string;
}

export const RxPaymentObjectInıtialValue: RxPaymentObject = {
	invoiceInfo: {
		isCompany: false,
		nameSurname: "",
		company: "",
		identityId: "",
		taxAdmin: "",
		taxNo: "",
		address: "",
		district: "",
		province: "",
		country: "",
	},
	deliveryInfo: {
		nameSurname: "",
		company: "",
		address: "",
		district: "",
		province: "",
		country: "",
		phone: "",
		note: "",
	},
	saleDetail: {
		id: 0,
		installment: false,
		products: [],
		licences: [],
		oldDistributor: {} as DistributorObject,
		distributor: {} as DistributorObject,
		totalDiscount: 0,
		totalPrice: 0,
		totalPriceWithKdv: 0,
	},
	maxInstallment: 1,
	isAgreementApprove: false,
	pan: "",
	cv2: "",
	Ecom_Payment_Card_ExpDate_Year: new Date().getFullYear().toString().slice(2),
	Ecom_Payment_Card_ExpDate_Month: "1",
	cardType: "1",
	instalment: "1",
	clientid: "",
	oid: "",
	amount: "",
	okUrl: "",
	failUrl: "",
	storetype: "",
	rnd: "",
	hash: "",
	firmaadi: "",
	islemtipi: "",
	currency: "",
};

export interface RxPaymentDetailResultObject {
	key: string;
	nameSurname: string;
	address: string;
	district: string;
	province: string;
	phone: string;
	company: string;
	licence: string;
	licenceCount: number;
	price: number;
	isFirstSale: boolean;
}

export interface POSPayment {
	posUrl: string;
	cardNumber: string;
	securityCode: string;
	expYear: string;
	expMonth: string;
	cardType: string;
	clientId: string;
	storeKey: string;
	oid: string;
	amount: string;
	okUrl: string;
	failUrl: string;
	storeType: string;
	rnd: string;
	hash: string;
	firmName: string;
	processType: string;
	instalment: string;
	currency: string;
	hashAlgorithm: string;
	lang: string;
}
